import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import styled, { css } from "styled-components";
import { Stars } from "./Stars";

const ProductStarsStyles = styled.div`
  ${({ ...props }) => css`
    margin-top: 16px;
    margin-bottom: 16px;

    a {
      text-decoration: underline;
      color: ${props.theme.colors.primary};
    }

    @media (min-width: ${props.theme.breakpoints.md}) {
      display: flex;
      align-items: center;
    }
  `}
`;

export const ProductStars = ({ productId, onClick, outOf = false }) => {
  let starsData = {
    allWpReview: {
      edges: []
    }
  }

  if (!process.env.STORYBOOK) {
    starsData = useStaticQuery(graphql`
      query StarsQuery {
        allWpReview {
          edges {
            node {
              customerReviews {
                reviewProduct {
                  ... on WpProduct {
                    id
                  }
                }
                attachToAdditionalProducts {
                  ... on WpProduct {
                    id
                  }
                }
                reviewRating
              }
            }
          }
        }
      }
    `);
  } else {
    starsData.allWpReview.edges.push({
      node: {
        customerReviews: {
          reviewProduct: {
            id: 'test'
          },
          reviewRating: 5
        }
      }
    })
  }

  function handleReviewLinkClick() {
    if (typeof onClick === 'function') {
      onClick();
    }
  }

  const reviews = starsData.allWpReview.edges;
  const currentReviews = reviews.filter(function (review) {
    if (review.node.customerReviews.reviewProduct) {
      const reviewProductId = review.node.customerReviews.reviewProduct.id;
      const attachedReviews =
        review.node.customerReviews.attachToAdditionalProducts;

      if (reviewProductId || attachedReviews) {
        if (reviewProductId === productId) {
          return true;
        } else if (
          attachedReviews &&
          attachedReviews.some((e) => e.id === productId)
        ) {
          return true;
        } else {
          return false;
        }
      }
    }
  });

  // Work out average

  let reviewRatings = [];
  currentReviews.map((review) => {
    const rating = review.node.customerReviews.reviewRating;
    reviewRatings.push(parseInt(rating, 10));
  });

  const average = (reviewRatings) => {
    let sum = reviewRatings.reduce(
      (previous, current) => (current += previous)
    );
    let avg = sum / reviewRatings.length;

    const fixedAverage = avg.toFixed(1)

    if (true === outOf) {
      return fixedAverage.replace(".0", "")
    }

    return fixedAverage;
  };

  // There may be more than one of these on the page due to component style
  // So just select one

  if (reviewRatings.length >= 1) {
    return (
      <ProductStarsStyles>
        <Stars aR={average(reviewRatings)} />
        <p>
          <strong>{average(reviewRatings)}{true === outOf && ' out of 5'}</strong>
          {" "}
          <small>
            {typeof onClick === 'function' ? (
              <a href={'javascript:void(0)'} onClick={handleReviewLinkClick}>
                ({reviewRatings.length} reviews)
              </a>
            ) : `(${reviewRatings.length} reviews)`}
          </small>
        </p>
      </ProductStarsStyles>
    );
  }

  return <></>
};
